import React, {Fragment} from "react";

const ReactHookFormError = ( { formErrors, name, path, subPath }) =>
{
    const style = {marginTop: '5px', color: 'red'};

    let errorObject = undefined;

    if ( path === undefined )
    {
        errorObject = formErrors.contact ;
    }
    else
    {
        if ( subPath === undefined )
        {
            errorObject = formErrors??[path] ;
        }
        else
        {
            if ( formErrors !== undefined )
            {
                errorObject = formErrors?.[path]?.[subPath] ;
            }
        }
    }

    return (
        <Fragment>
            { errorObject !== undefined && errorObject[name] && errorObject[name].type === "required" && <div style={style}>This is required</div>}
            { errorObject !== undefined && errorObject[name] && errorObject[name].type === "maxLength" && <div style={style}>Max length exceeded</div> }
            { errorObject !== undefined && errorObject[name] && errorObject[name].type === "validate" && <div style={style}>{errorObject[name].message}</div> }
        </Fragment>
    )
}

export default  ReactHookFormError ;
